














































import { Component, Vue, Prop } from "vue-property-decorator";
import { PostExpertYypw, PostExpertYyty, PostExpertSzjj } from "@/request/dig";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import LeftNav from "../../../components/left-nav.vue";
import StartAnalysisCmp from "../../../components/start-analysis-cmp.vue";
import ResultFilterCmp from "../../../components/result-filter-cmp.vue";
import Result from "./yongyao-result.vue";
import Waiting from "../../../components/waiting.vue";
import Copy from "@/components/copy.vue";
@Component({
  components: {
    MainHeader,
    LeftNav,
    StartAnalysisCmp,
    ResultFilterCmp,
    Result,
    Waiting,
    Copy,
  },
})
export default class DigExpertYongyao extends Vue {
  private message: any = {
    project_id: "",
    table_id: "",
    分析名称: "用药配伍",
    中医证型: "全部",
    统计个数: 6,
    其它: false,
    支持度: 80,
    置信度: 80,
  };
  private result: any = {
    用药频次统计明细: {},
    药对统计明细: {},
    药物关联规则明细: {},
    随症用药规律明细: {},
  };
  private ifGotResult: boolean = false;
  private cFenxi: any = "用药配伍";
  /**
   * @description 重新回到等待状态
   */
  private reWait() {
    this.ifGotResult = false;
  }
  /**
   * @description 重置条件
   */
  private resetMessage(type) {
    this.cFenxi = type;
    if (type === "用药配伍") {
      this.message["分析名称"] = "用药配伍";
      this.message["中医证型"] = "全部";
    } else if (type === "用药特异性分析") {
      this.message["分析名称"] = "用药特异性分析";
    } else if (type === "随症用药规律") {
      this.message["分析名称"] = "随症用药规律";
    }
    this.message["统计个数"] = 6;
    this.message["其它"] = false;
    this.message["支持度"] = 80;
    this.message["置信度"] = 80;
  }
  /**
   * @description 切换当前分析方法
   */
  private typeChange(type) {
    this.resetMessage(type);
    this.analysis();
  }
  /**
   * @description 切换当前分析方法
   */
  private zyzxChange(value) {
    this.message["中医证型"] = value;
    this.analysis();
  }
  /**
   * @description 开始分析
   */
  private analysis() {
    this.ifGotResult = false;
    const load = this.$loading({
      text: "分析中...请稍后",
    });
    const params: any = this.message;
    if (this.cFenxi === "用药配伍") {
      PostExpertYypw(this, params)
        .then((data: any) => {
          this.result = data;
          this.ifGotResult = true;
        })
        .catch(() => {
          this.resetMessage(this.cFenxi);
        })
        .finally(() => {
          load.close();
        });
    } else if (this.cFenxi === "用药特异性分析") {
      PostExpertYyty(this, params)
        .then((data: any) => {
          this.result = data;
          this.ifGotResult = true;
        })
        .catch(() => {
          this.resetMessage(this.cFenxi);
        })
        .finally(() => {
          load.close();
        });
    } else if (this.cFenxi === "随症用药规律") {
      PostExpertSzjj(this, params)
        .then((data: any) => {
          this.result = data;
          this.ifGotResult = true;
        })
        .catch(() => {
          this.resetMessage(this.cFenxi);
        })
        .finally(() => {
          load.close();
        });
    }
  }
  /**
   * @description 处理内部发出的结果变化
   */
  private handleResultChange(result) {
    this.result = result;
  }
}
